import PdfFatura from "./PdfFatura";
import PdfNCE from "./PdfNCE";

function PdfFaturaWrapper({ showPreviousPage, faturaData }) {
  const showPreviousP = () => {
    showPreviousPage();
  };

  return (
    <div>
      {faturaData.tipoDocumento === "NCE" ? (
        <PdfNCE faturaData={faturaData} showPreviousPage={showPreviousP} />
      ) : (
        <PdfFatura faturaData={faturaData} showPreviousPage={showPreviousP} />
      )}
    </div>
  );
}

export default PdfFaturaWrapper;
